
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useAdminState = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("dashboard");
  const [accountPerformances, setAccountPerformances] = useState<any[]>([]);
  const [loadingStripe, setLoadingStripe] = useState(false);
  const [userRole, setUserRole] = useState<string | null>(null);
  const [providerId, setProviderId] = useState<string | null>(null);
  
  const [stripeSubscriptions, setStripeSubscriptions] = useState({
    monthly: 0,
    yearly: 0,
    total: 0,
    activeCanceled: 0,
    subscriptions: []
  });

  // Set default tab based on user role
  useEffect(() => {
    if (userRole === 'editor') {
      setActiveTab('articles');
    }
  }, [userRole]);
  
  // Handle tab state from router locations
  useEffect(() => {
    // Handle state preservation when navigating back to admin
    if (location.pathname === '/admin' && location.state?.activeTab) {
      console.log("useAdminState: Restoring tab from location state:", location.state.activeTab);
      setActiveTab(location.state.activeTab);
    }
  }, [location]);

  return {
    activeTab,
    setActiveTab,
    accountPerformances,
    setAccountPerformances,
    loadingStripe,
    setLoadingStripe,
    userRole,
    setUserRole,
    providerId,
    setProviderId,
    stripeSubscriptions,
    setStripeSubscriptions
  };
};
